module.exports = __webpack_public_path__ + "img/Service-2021.bc8635ad.png";